import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const NAV_UPLOAD_FILE = 'upload file'
export const DOCUMENT_EDITOR = 'document editor'
export const ALL_SURVEYS = 'all surveys'
export const SAVE_DRAFT = 'save draft'
export const FORWARD = 'forward'
export const BUILD_SURVEY = 'build survey'
export const QUESTION = 'question'
export const ANSWER = 'answer'
export const SUB_QUESTION = 'sub question'
export const SURVEY_SAVED = 'survey saved with success'
export const GROUP = 'group'

export default {
  [PORTUGUESE]: {
    [NAV_UPLOAD_FILE]: 'Subir Arquivo',
    [DOCUMENT_EDITOR]: 'Editor de Documentos',
    [ALL_SURVEYS]: 'Todas as Pesquisas',
    [SAVE_DRAFT]: 'Salvar Rascunho',
    [FORWARD]: 'Avançar',
    [BUILD_SURVEY]: 'Construir Pesquisa',
    [QUESTION]: 'Pergunta',
    [ANSWER]: 'Resposta',
    [SUB_QUESTION]: 'Subpergunta',
    [SURVEY_SAVED]: 'Pesquisa salva com sucesso',
    [GROUP]: 'Grupo',
  },

  [ENGLISH]: {
    [NAV_UPLOAD_FILE]: 'Upload File',
    [DOCUMENT_EDITOR]: 'Document Editor',
    [ALL_SURVEYS]: 'All Surveys',
    [SAVE_DRAFT]: 'Save Draft',
    [FORWARD]: 'Forward',
    [BUILD_SURVEY]: 'Build Survey',
    [QUESTION]: 'Question',
    [ANSWER]: 'Answer',
    [SUB_QUESTION]: 'Sub Question',
    [SURVEY_SAVED]: 'Survey saved with success',
    [GROUP]: 'Group',
  },

  [SPANISH]: {
    [NAV_UPLOAD_FILE]: 'Subir Archivo',
    [DOCUMENT_EDITOR]: 'Editor de Documentos',
    [ALL_SURVEYS]: 'Todas las Encuestas',
    [SAVE_DRAFT]: 'Guardar Borrador',
    [FORWARD]: 'Hacia Adelante',
    [BUILD_SURVEY]: 'Construir Encuesta',
    [QUESTION]: 'Pregunta',
    [ANSWER]: 'Respuesta',
    [SUB_QUESTION]: 'Sub pregunta',
    [SURVEY_SAVED]: 'Encuesta guardada con éxito',
    [GROUP]: 'Grupo',
  },
}
